import React from 'react';
import { Circle } from '@mui/icons-material';
import { Theme } from '@mui/material/styles';
import makeStyles from '@mui/styles/makeStyles';
import { Box, Stack, Typography } from '@mui/material';
import { RenderWithCondition } from 'components/shared/Conditional/RenderWithCondition';

import { StatePipelineRender } from './types';

interface Props {
  isFirstItem: boolean;
  isLastItem: boolean;
  timelineItem: StatePipelineRender;
}

export const StageTimelineInfo = ({ timelineItem, isFirstItem, isLastItem }: Props) => {
  const classes = useStyles();

  return (
    <Box className={classes.container}>
      <Box className="timelineItem">
        <Stack alignItems="flex-end">
          <Typography component="span" fontWeight="bold">
            {timelineItem.label}
          </Typography>

          <Typography variant="body2" color="textSecondary">
            {timelineItem.completedAt}
          </Typography>
        </Stack>

        <Circle color="primary" sx={{ fontSize: '1rem' }} />

        <RenderWithCondition condition={isFirstItem}>
          {timelineItem?.isLastStep ? (
            <Typography fontWeight="bold">In progress: {timelineItem.timeGap}</Typography>
          ) : (
            <Box>
              <Typography fontWeight="bold">{timelineItem.timeGap}</Typography>

              <Typography variant="body2" color="textSecondary">
                By {timelineItem.completedBy}
              </Typography>
            </Box>
          )}
        </RenderWithCondition>
      </Box>

      <RenderWithCondition condition={!isLastItem}>
        <Box className={classes.line} />
      </RenderWithCondition>
    </Box>
  );
};

const useStyles = makeStyles<Theme>(({ palette }) => ({
  container: {
    gap: '0.5rem',
    display: 'flex',
    alignItems: 'center',
    flexDirection: 'column',

    '& .timelineItem': {
      gap: '1rem',
      display: 'grid',
      alignItems: 'center',
      gridTemplateColumns: '1fr auto 1fr',
    },
  },
  line: {
    height: '2.5rem',
    width: '0.1rem',
    borderRadius: '0.5rem',
    backgroundColor: palette.primary.light,
  },
}));
